module.exports = "button.button-align-bottom {\n    position: relative;\n    top: 100%;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/inactives/inactives.component.css
// module id = ./src/app/articles/inactives/inactives.component.css
// module chunks = main